var _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 120,
    viewBox: "0 0 134 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.7266,
    cy: 61,
    r: 39,
    fill: "#E7FFF2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.7266,
    cy: 61,
    r: 30.6885,
    fill: "#56C654"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.539 62.7242L69.4115 70.142L86.6123 50.3094",
    stroke: "white",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.1213,
    cy: 4.24242,
    r: 4.24242,
    fill: "#C25CFE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.0911,
    cy: 115.758,
    r: 4.24242,
    fill: "#14A3BE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.545,
    cy: 60,
    r: 4.24242,
    fill: "#72D4FE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5764,
    cy: 44.8485,
    r: 4.24242,
    fill: "#FDB338"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.455,
    cy: 111.818,
    r: 3.93939,
    fill: "#70C043"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.3338,
    cy: 10.303,
    r: 1.81818,
    fill: "#F5B40C"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5457,
    cy: 109.697,
    r: 1.81818,
    fill: "#F5B40C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.03 26.0606C116.758 26.2626 126.918 26.0606 125.848 16.9697C125.444 13.5353 126.455 6.48484 133.727 5.75757",
    stroke: "#F25687",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.667 97.5757C110.697 97.9797 116.879 101.151 117.364 110.606",
    stroke: "#FFC120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 87.2728C6.9596 89.293 19.4849 90.1213 21.9091 77.2728C21.9091 70.3031 17.3636 68.0607 14.9394 73.6364C13.1212 81.5152 23.2424 87.4546 32.2121 73.6364",
    stroke: "#77D1F7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7a1692625561ee00bb25c24235b874ca.svg";
export { ForwardRef as ReactComponent };